import type {
    CardPointeFundingRequestDetails,
    CardPointeFundingResponseDetails,
} from './cardpointe-funding.types';

export const CardPointeReconciliationLookupOutcome = {
    MATCHED: 'matched',
    UNMATCHED: 'unmatched',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CardPointeReconciliationLookupOutcome =
    (typeof CardPointeReconciliationLookupOutcome)[keyof typeof CardPointeReconciliationLookupOutcome];

export interface CardPointeReconciliationLookupRequest {
    readonly funding_date: string;
    readonly gateway_txn_id: string;
    readonly page?: number;
    readonly limit?: number;
}

export interface CardPointeReconciliationLookupRequestDetails {
    readonly fundingRequestDetails: CardPointeFundingRequestDetails;
    readonly lookup: CardPointeReconciliationLookupRequest;
}

export interface CardPointeReconciliationLookupResult {
    readonly gateway_txn_id: string;
    readonly is_settled: boolean;
    readonly batched_amount?: number;
    readonly gateway_batch?: string;
    readonly settlement_status?: string;
    readonly funding_id?: string;
    readonly funding_transaction_id?: string;
}

export type CardPointeReconciliationLookupResponseDetails =
    | {
          readonly outcome: typeof CardPointeReconciliationLookupOutcome.MATCHED;
          readonly httpStatus: 200;
          readonly fundingResponseDetails: CardPointeFundingResponseDetails;
          readonly normalizedResult: CardPointeReconciliationLookupResult;
      }
    | {
          readonly outcome: typeof CardPointeReconciliationLookupOutcome.UNMATCHED;
          readonly httpStatus: number;
          readonly fundingResponseDetails: CardPointeFundingResponseDetails;
          readonly message: string;
      }
    | {
          readonly outcome: typeof CardPointeReconciliationLookupOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly fundingResponseDetails: CardPointeFundingResponseDetails;
          readonly message: string;
      };
